import Nullstack from 'nullstack';
export default function IconWall({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wall",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "4",
    y: "4",
    width: "16",
    height: "16",
    rx: "2"
  }), "   ", Nullstack.element("path", {
    d: "M4 8h16"
  }), "   ", Nullstack.element("path", {
    d: "M20 12h-16"
  }), "   ", Nullstack.element("path", {
    d: "M4 16h16"
  }), "   ", Nullstack.element("path", {
    d: "M9 4v4"
  }), "   ", Nullstack.element("path", {
    d: "M14 8v4"
  }), "   ", Nullstack.element("path", {
    d: "M8 12v4"
  }), "   ", Nullstack.element("path", {
    d: "M16 12v4"
  }), "   ", Nullstack.element("path", {
    d: "M11 16v4"
  }), " ");
}